import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { SiteSurveyOptionForm, SiteSurveyOptionFormType } from './SiteSurveyOptionForm'
import { getSiteSurveyOptionById, updateSiteSurveyOption } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Site Survey Options',
    path: '/system/site-survey-options'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditSiteSurveyOption = () => {
  const { optionId } = useParams()
  const { createToast } = useAppContext()
  const [option, setOption] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getSiteSurveyOptionById(optionId)
        setOption(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateSiteSurveyOption(optionId, {
        description: form.description,
        cost: form.cost
      })
      if (row) {
        setOption(row)
        createToast('success', 'Site survey option updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Site Survey Option</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Option Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <SiteSurveyOptionForm
              type={SiteSurveyOptionFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={option}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
